import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function CreateQR() {
  const [form, setForm] = useState({ title: '', target_url: '', category_id: '', fg_color: '#000000', bg_color: '#ffffff' });
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => { api.get('/categories').then(r => setCategories(r.data)); }, []);

  const set = key => e => setForm({ ...form, [key]: e.target.value });

  const submit = async e => {
    e.preventDefault();
    try {
      const payload = { ...form };
      if (!payload.category_id) delete payload.category_id;
      const { data } = await api.post('/qr', payload);
      navigate(`/qr/${data.id}`);
    } catch (err) { setError(err.response?.data?.error || 'Failed'); }
  };

  const inputStyle = { width: '100%', padding: 12, border: '1px solid #ddd', borderRadius: 8, fontSize: 14, marginBottom: 14 };

  return (
    <div style={{ maxWidth: 500 }}>
      <h2 style={{ marginBottom: 20 }}>Create QR Code</h2>
      <form onSubmit={submit} style={{ background: '#fff', padding: 28, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,.06)' }}>
        {error && <p style={{ color: 'red', marginBottom: 12 }}>{error}</p>}
        <label style={{ fontWeight: 600, fontSize: 13, display: 'block', marginBottom: 4 }}>Title</label>
        <input value={form.title} onChange={set('title')} required style={inputStyle} placeholder="My QR Code" />

        <label style={{ fontWeight: 600, fontSize: 13, display: 'block', marginBottom: 4 }}>Target URL</label>
        <input value={form.target_url} onChange={set('target_url')} required type="url" style={inputStyle} placeholder="https://example.com" />

        <label style={{ fontWeight: 600, fontSize: 13, display: 'block', marginBottom: 4 }}>Category</label>
        <select value={form.category_id} onChange={set('category_id')} style={inputStyle}>
          <option value="">None</option>
          {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>

        <div style={{ display: 'flex', gap: 16, marginBottom: 14 }}>
          <div style={{ flex: 1 }}>
            <label style={{ fontWeight: 600, fontSize: 13, display: 'block', marginBottom: 4 }}>Foreground</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input type="color" value={form.fg_color} onChange={set('fg_color')} style={{ width: 40, height: 40, border: 'none', cursor: 'pointer' }} />
              <input value={form.fg_color} onChange={set('fg_color')} style={{ ...inputStyle, marginBottom: 0, flex: 1 }} />
            </div>
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ fontWeight: 600, fontSize: 13, display: 'block', marginBottom: 4 }}>Background</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input type="color" value={form.bg_color} onChange={set('bg_color')} style={{ width: 40, height: 40, border: 'none', cursor: 'pointer' }} />
              <input value={form.bg_color} onChange={set('bg_color')} style={{ ...inputStyle, marginBottom: 0, flex: 1 }} />
            </div>
          </div>
        </div>

        {/* Preview */}
        <div style={{ textAlign: 'center', padding: 20, background: form.bg_color, borderRadius: 8, marginBottom: 16, border: '1px solid #eee' }}>
          <div style={{ width: 120, height: 120, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: 2 }}>
            {Array.from({length: 25}).map((_, i) => (
              <div key={i} style={{ background: [0,1,2,3,4,5,6,10,14,20,21,22,23,24].includes(i) ? form.fg_color : form.bg_color, borderRadius: 2 }} />
            ))}
          </div>
          <p style={{ marginTop: 8, fontSize: 12, color: '#888' }}>Color preview</p>
        </div>

        <button type="submit" style={{ width: '100%', padding: 14, background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 600, cursor: 'pointer' }}>Create QR Code</button>
      </form>
    </div>
  );
}
